<template>
  <div style="height: 100%">
    <file-component fileType="image"/>
  </div>
</template>

<script>
import FileComponent from '../part/FileComponent'

export default {
  name: 'index',
  components: {FileComponent},
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/file/img/index.vue